<div #mainDiv_ll_model_cash>

  <div [style.top.px]="bundle.horzTabsY"
       [style.left.px]="bundle.remainingX"
       style="position: absolute;z-index:200">

    <span style="display: inline-block; width: 60px; padding: 5px; font-weight: 500; font-size: small;">
      Month:
    </span>

    <select style="padding: 5px; font-size: small; min-width: 100px;"
            [(ngModel)]="bundle.monthChoice"
            (change)="onMonthChange($event)">

      <option *ngFor="let month of bundle.monthList"
              [value]="month.CHOICE">
        {{ month.LABEL }}
      </option>
    </select>
  </div>

  <!--<div [style.top.px]="bundle.horzTabsY"
       [style.left.px]="bundle.remainingX + 200"
       style="position: absolute;z-index:200">

    <span style="display: inline-block; width: 70px; padding: 5px; font-weight: 500; font-size: small;">
      Location:
    </span>

    <select style="padding: 5px; font-size: small; min-width: 125px;"
            [(ngModel)]="bundle.locationIdChoice"
            (change)="onLocationChange($event)">

      <option *ngFor="let location of bundle.locationList"
              [value]="location.LOCATIONID">
        {{location.LOCATIONNAME }}
      </option>
    </select>
  </div>-->

  <!-- TABS ACROSS THE TOP - ALL IN ONE ROW -->
  <div [hidden]="!bundle.showHorzTabs"
       [style.top.px]="bundle.horzTabsY + 40"
       [style.left.px]="bundle.remainingX"
       [style.width.px]="bundle.remainingW"
       style="position: absolute;
       z-index: 200;
       display: flex;
       align-items: center;
       flex-wrap: wrap;
            gap: 12px;
            min-height: 38px;
            background: white;
            overflow: hidden;
            padding: 4px 0 8px 0;">

    <!-- General Section -->
    <div *ngFor="let gen of bundle.horzTabs; let i = index"
         style="cursor:pointer; white-space: nowrap;"
         (click)="selectTab(gen.CODE)">

      <div *ngIf="gen.CODE === bundle.activeCODE"
           class="wordBtn14_selected"
           style="display: inline-block; padding-right: 6px;">
        {{ gen.LABEL }}
      </div>

      <div *ngIf="gen.CODE !== bundle.activeCODE"
           class="wordBtn14"
           style="display: inline-block; padding-right: 6px;">
        {{ gen.LABEL }}
      </div>
    </div>

  </div>

  <div [hidden]="!bundle.showGrid"
       [style.top.px]="bundle.remainingY"
       [style.left.px]="bundle.remainingX"
       [style.width.px]="bundle.remainingW"
       [style.height.px]="bundle.remainingH"
       style="position: absolute; z-index: 100">

    <jqxGrid #datagrid_ll_model_cash
             [width]="bundle.gridW"
             [height]="bundle.gridH"
             [editable]="true"
             [editmode]="'click'"
             [rowsheight]="20"
             [filterable]="true"
             [sortable]="true"
             [showheader]="true"
             [columnsresize]="true"
             [showstatusbar]="false"
             (onCellvaluechanged)="clickOnRow($event)"
             (onCellclick)="clickOnRow($event)">


    </jqxGrid>

    <div style="padding-top: 10px">
      <div class="wordBtn_11" (click)="exportOnClick()">Download Above List</div>    
    </div>

  </div>


</div>
